import * as React from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../redux';
import {InjectedFormProps, reduxForm} from 'redux-form';

import View from './view';
import {ProductsAcceptorFilterForm} from '../model';
import {Forms} from '../../../../shared/models/forms';
import {productAcceptorsSelector} from '../../../../redux/selectors/products';
import {getListProductAcceptors} from '../../../../redux/actions/products';

export interface ProductsAcceptorFilterProps {
  visuallyImpaired?: boolean;
  onFilterApply?: (formData: ProductsAcceptorFilterForm) => void;
}

const _ProductsAcceptorFilter: React.FC<
  ProductsAcceptorFilterProps & InjectedFormProps<ProductsAcceptorFilterForm, ProductsAcceptorFilterProps>
> = ({onFilterApply = () => undefined, handleSubmit, ...props}) => {
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    dispatch(getListProductAcceptors());
  }, []);

  const productAcceptors = useSelector(productAcceptorsSelector());
  const onSubmit = React.useCallback((e: any) => {
    e?.preventDefault();
    handleSubmit(onFilterApply)();
  }, []);

  return <View onSubmit={onSubmit} productAcceptors={productAcceptors} {...props} />;
};

export const ProductsAcceptorFilter = reduxForm<ProductsAcceptorFilterForm, ProductsAcceptorFilterProps>({
  form: Forms.productsAcceptorFilterForm,
  destroyOnUnmount: false,
})(_ProductsAcceptorFilter);
